<template>
  <div class="cards-layout">
    <div
      v-if="hasHeader"
      class="cards-layout__header"
    >
      <BasicText size="h5">
        {{ headerText ?? cardsType }}
      </BasicText>
      <BasicLink
        label="Tout voir"
        class="cards-layout__desktop"
        :disabled="isDisabled"
        wrap-link
        @click="() => !isDisabled && redirection?.()"
      />
    </div>
    <div
      v-if="cards && cards.length > 0"
      :class="[{ 'cards-layout__flex': cardsType !== 'Tâches' }, { 'cards-layout__grid': cardsType === 'Tâches' }]"
    >
      <BasicCard
        v-for="(card, index) in cards.slice(0, 6)"
        :key="index"
        v-bind="card"
        @click="() => !isDisabled && card.onCardClick?.()"
      />
    </div>

    <div
      v-else-if="cardsType !== 'Rattachements'"
      class="cards-layout__empty"
    >
      <BasicIcon name="empty-cards-layout" />
      <BasicText>{{ labelMapping[cardsType]?.emptyCardLibelle }}</BasicText>
    </div>
    <div
      v-else
      class="cards-layout__empty cards-layout__empty--fill"
    >
      <BasicIcon name="empty-cards-layout" />
      <div class="cards-layout__empty-box">
        <BasicText color="white">
          {{ labelMapping[cardsType]?.emptyCardLibelle }}
        </BasicText>
        <BasicButton
          @click="labelMapping[cardsType]?.emptyCardRedirection"
          label="Configurer mon rattachement"
          icon-name="setting"
        />
      </div>
    </div>
    <div
      v-if="hasHeader"
      class="cards-layout__mobile"
    >
      <BasicButton
        @click="() => !isDisabled && redirection?.()"
        label="Tout voir"
        width="full"
        type="secondary"
        class="cards-layout__btn-redirection"
        :disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
import { type CardsLayoutProps, labelMapping } from './CardsLayout.types';

  const props = withDefaults(defineProps<CardsLayoutProps>(), {
    selectionnable: false,
    hasHeader: true,
  })

  defineEmits(['card-click'])

  const isDisabled = computed(() => !props.cards || !props.cards.length)
</script>

<style scoped lang="less">
  @import './CardsLayout.less';
</style>
